import { Button, Hairline, Input, Textarea, Checkbox } from "@components";
import { If } from "@components/control-statements";
import { useDebouncedCallback } from "@hooks";
import { FlowAPI } from "@providers/FlowAPI";
import { useState, useEffect } from "react";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";

import styles from "@styles/forms-flow/creative.module.scss";
import { Environment } from "shared/core/Environment";

const MAX_CHARS_RECOMENDATION = 160;

export const PushMessage = ({
  message,
  senderName,
  url,
  coupon,
  onChangeCreative,
}) => {
  const [urlParams, setUrlParams] = useState(false);
  const [holdingId, setHoldingId] = useState(null);
  const isCocoBambu = Environment.id === 49;

  const getTotalChars = () => {
    const final = replaceTags(message?.template || "", coupon) || "";
    return final.length;
  };
  const getHoldingId = async () => {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    setHoldingId(holdingId);
  };
  useEffect(() => {
    getHoldingId();
  }, []);

  const setMessage = (data) => {
    onChangeCreative({
      ...(message || {}),
      ...data,
      type: "PUSH",
    });
  };
  const isCiaTC = holdingId && holdingId === 811;
  return (
    <>
      <Input
        prefix="Título"
        placeholder="Título"
        prefixWidth={75}
        maxLength={isCocoBambu ? 45 : 75}
        autoFocus
        className="mb-20"
        value={message?.title}
        onChange={(title) => setMessage({ title: title.target.value })}
      />

      <p className={styles.label}>Escreva a mensagem que será enviada</p>
      <Textarea
        label="Mensagem"
        className="mt-20"
        design="two"
        maxLength={isCocoBambu ? 107 : MAX_CHARS_RECOMENDATION}
        onKeyDown={(e) => {
          const finalMessage =
            replaceTags(message?.template || "", coupon) || "";

          const controlKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
          ];

          if (
            finalMessage.length >=
              (isCocoBambu ? 107 : MAX_CHARS_RECOMENDATION) &&
            !controlKeys.includes(e.key)
          )
            e.preventDefault();
        }}
        value={message?.template}
        onChange={(e) => setMessage({ template: e.target.value })}
      />

      <div className="d-flex justify-end">
        <p className={styles.charactersCount}>
          <span className={styles.number}>{getTotalChars()} / </span>
          <span className={styles.type}>
            {isCocoBambu ? 107 : MAX_CHARS_RECOMENDATION} caracteres
          </span>
        </p>
      </div>
      {/* Atividade inicialmente desenvolvida apenas para ciatc */}
      {isCiaTC && (
      <><Hairline className="mt-20" /><Checkbox
          className="mt-20 mb-20"
          checked={urlParams}
          onChange={() => setUrlParams(!urlParams)}
        >
          Redirecionar o usuário para uma tela personalizada
        </Checkbox></>
    )}
      {urlParams && (
        <div className="d-flex gap-10 mt-10 mb-10">
          <p className={`${styles.label} mt-10`}>
            https://app.ciatradicional.com.br/
          </p>
          <Input
            prefix="Parâmetro"
            placeholder="Parâmetro"
            prefixWidth={15}
            autoFocus
            className="w-100 mb-0"
            value={message?.params || ""}
            onChange={(e) => setMessage({ ...message, params: e.target.value })}
          />
        </div>
      )}
      <Hairline className="mt-30 mb-30" />

      <p className={styles.label}>Pré-visualização</p>
      <pre
        className={styles.previewMessage}
        dangerouslySetInnerHTML={{
          __html: replaceGaps(message?.template, coupon) || ``,
        }}
      />

      <PushTriggerShot
        message={message}
        coupon={coupon}
        sender={senderName}
        url={url}
      />
    </>
  );
};

const replaceTags = (template, coupon) => {
  const message = template || "";
  let tagPairs = [];

  if (coupon?.code)
    tagPairs = [{ from: /\<cupom\>/gi, to: `${coupon?.code}-A10` }];

  return tagPairs?.reduce(
    (str, tag) => str?.replace(tag.from, tag.to),
    String(message)
  );
};

const replaceGaps = (template, coupon) => {
  const message = template || "";
  let tagPairs = [];

  if (coupon?.code)
    tagPairs = [
      {
        from: /\<cupom\>/gi,
        to: `<span style="color:#6161ff">${coupon?.code}-A10</span>`,
      },
    ];

  return tagPairs
    ?.reduce((str, tag) => str?.replace(tag.from, tag.to), String(message))
    ?.replace(/(<\/?(?:span)[^>]*>)|<[^>]+>/gi, "$1");
};

const PushTriggerShot = ({ url, message, coupon, sender }) => {
  const [phones, setPhones] = useState("");
  const [remainTime, setRemainTime] = useState(0);
  const [isWaitingSending, setIsWaitingSending] = useState(false);

  const prefix = "+55";

  const sendPushTest = async () => {
    const environmentId = Environment.id;

    if (!validatePhoneAndPrefix()) {
      return;
    }

    const phone = `${prefix}${phones}`.replace(/[^0-9]/g, "");

    let benefit = "";
    if (coupon && coupon.code) {
      benefit = `${coupon?.code}-A10`;
    }

    const response = await FlowAPI.sendPushTest(environmentId, {
      phone: [phone],
      urlType: url?.type,
      title: message?.title,
      template: message?.template,
      params: message?.params,
      replacements: {
        "<cupom>": benefit,
        "<link>": url?.url,
        "<remetente>": sender,
      },
    });

    if (response.getCode(500) != 200) {
      const errorMessage = response.getErrors([
        "Ocorreu um erro no sistema!",
      ])[0];
      alert({ text: errorMessage });
      setIsWaitingSending(false);
      return;
    }

    setIsWaitingSending(true);
    const startTimer = () => {
      let startTime = 60;
      const intervalId = setInterval(() => {
        setRemainTime(startTime--);
        if (startTime == -1) {
          clearInterval(intervalId);
          setIsWaitingSending(false);
        }
      }, 1000);
    };
    startTimer();
  };

  const onSendPush = useDebouncedCallback(sendPushTest, 1000);

  const validatePhoneAndPrefix = () => {
    const phoneValid = phones.replace(/\D/g, "").length === 11;
    const prefixValid = /^\+\d{2}$/.test(prefix);
    return phoneValid && prefixValid;
  };

  return (
    <>
      <p className={styles.label}>Disparo teste</p>
      <p className={styles.sublabel}>
        Insira um número de telefone cadastrado no aplicativo, para que possamos
        enviar um teste. Lembre-se, você só receberá a simulação se tiver{" "}
        <b>logado</b> no aplicativo, em um cadastro com o mesmo número que será
        inserido abaixo.
      </p>
      <div className={styles.testMessage}>
        <div className="d-flex align-center">
          <Input
            placeholder="(00) 00000-0000"
            className="w-100"
            center
            value={phones}
            mask="(99) 99999-9999"
            onChange={(e) => setPhones(e.target.value)}
            disabled={isWaitingSending}
          />
        </div>

        <Button
          design="four"
          className={`mt-20 w-100`}
          disabled={
            isWaitingSending || (!isWaitingSending && !validatePhoneAndPrefix())
          }
          onClick={onSendPush}
        >
          Disparar
          <If cond={remainTime > 0}>
            <span>
              &nbsp;(
              {`${`${Math.floor(remainTime / 60)}`.padStart(2, "0")}:${`${
                remainTime % 60
              }`.padStart(2, "0")}`}
              )
            </span>
          </If>
        </Button>
      </div>
    </>
  );
};
